import { Pipe, PipeTransform } from '@angular/core';
import { EvaluationStandardRecord } from '@masar/features/evaluate/types';

@Pipe({
    name: 'evaluationRecordRangeLabel',
    standalone: false,
})
export class EvaluationRecordRangeLabelPipe implements PipeTransform {
    public transform(record?: EvaluationStandardRecord | null): string {
        const min = record?.from ?? 0;
        const max = record?.target ?? 0;
        return `${min} - ${max}`;
    }
}
